import { render, staticRenderFns } from "./WebhooksTable.vue?vue&type=template&id=42e91d48"
import script from "./WebhooksTable.vue?vue&type=script&lang=js"
export * from "./WebhooksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports